/*
@author: NN
@createdOn: Feb 13, 2018
@desc: Common component to view a the mod history a single sla, labor category etc. This common component pop's up a overlay panel.
*/

import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {OverlayPanel} from "primeng/overlaypanel";
import {plainToClass, Type} from "class-transformer";

import {DefaultRowsDT, serializeType} from '../classes/common';
import {Format} from '../enums/format.enum';
import {CommonTransformationService} from '../services/common-transformation.service';
import {ModHistoryService} from "../mod-history/mod-history-service";
import {ContractModTypeName} from "@app/shared/classes/contract";
import {ModHistoryType, ProjectModTypeName, TableColumn, TableFormat} from "@app/shared";
import {LabelHTMLAttributes} from "react";

@Component({
  selector: 'app-mod-history',
  templateUrl: './mod-history.component.html',
  styleUrls: ['./mod-history.component.css'],
  providers: [ModHistoryService],
})
export class ModHistoryComponent implements OnInit, AfterViewInit {

  @Input() componentId: number;
  @Input() type: ContractModTypeName | ProjectModTypeName | ModHistoryType;
  @Input() noShowButton: boolean;
  @Input() event;
  @Input() target;

  @Output() onHideHandler = new EventEmitter<boolean>();

  // standard format and validation
  Format: typeof Format = Format;
  defaultRowsDT = DefaultRowsDT;

  modHistories: ModHistory[];
  tableColumns: TableColumn[];

  @ViewChild('op') op: OverlayPanel;
  @ViewChild('actualTarget') actualTarget: LabelHTMLAttributes<string>;

  constructor(private modHistoryService: ModHistoryService, private commonTransService: CommonTransformationService) {
  }

  ngOnInit() {
    this.initTableColumns();
  }

  ngAfterViewInit() {
    if (this.noShowButton) {
      this.onClickShowModHistory(this.event, this.op, this.target);
    }
  }

  onClickShowModHistory(event, op: OverlayPanel, target) {

    if (this.componentId != null) {
      let componentType;
      if (this.type.includes('PROJECT')) {
        componentType = 'projects';
      } else if (this.type == ContractModTypeName.BidRate) {
        componentType = 'contract';
      } else {
        componentType = 'contract';
      }
      this.modHistoryService.getModHistory(componentType, this.componentId, this.type).subscribe(res => {
        this.modHistories = plainToClass(ModHistory, res.list);
        op.show(event, target);
      });
    }
  }

  onHideOverlayPanel(event) {
    this.onHideHandler.emit(event);
  }

  private initTableColumns(): void {
    this.tableColumns = [
      {field: 'modNumber', header: 'Mod'},
      {field: 'propertyName', header: 'Property'},
      {field: 'beforeValue', header: 'Before'},
      {field: 'afterValue', header: 'After'},
      {field: 'modifiedOn', header: 'Last Modified', format: TableFormat.Date},
      {field: 'userFullName', header: 'By'}
    ];
  }
}

export class ModHistory {
  modNumber: number;
  classname: number;
  propertyName: string;
  beforeValue: any;
  afterValue: any;
  @Type(serializeType(Date)) modifiedOn: Date;
  userFullName: string;
}
